import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

const BotPublishPage = ({
  appurl = '',
  bid = '',
  sess = { mobile: '' },
}) => {
  const [scriptValue] = useState(
    `<script async defer src='${appurl}/public/assets/wapublish.js' id='helper' data-cl='${sess.mobile}' data-bid='${bid}'></script>`
  );

  const handleUpdate = () => {
    // TODO: Implement update functionality via API
    console.log('Update clicked');
  };

  return (
    <Box sx={{ p: 2 }}>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Whatsapp Script
          </Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={8}>
              <TextField
                fullWidth
                value={scriptValue}
                InputProps={{ readOnly: true }}
                label="Embed Script"
                size="small"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Stack direction="row" justifyContent={{ xs: 'flex-start', md: 'flex-end' }}>
                <Button
                  variant="contained"
                  onClick={handleUpdate}
                  sx={{ mt: { xs: 1, md: 0 } }}
                >
                  Update
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default BotPublishPage;
